"use client";

import { motion } from "framer-motion";
import styles from "./ProcedureHeader.module.css";

export default function ProcedureHeader() {
  return (
    <motion.header
      className={styles.procedureHeader}
      initial={{ opacity: 0, y: -40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <h2 className={styles.procedureTitle}>
        Quy trình xây dựng website chuyên nghiệp và hiệu quả
      </h2>
      <p className={styles.procedureSubtitle}>
        Chúng tôi mang đến giải pháp website toàn diện với quy trình 4 bước được tối ưu hoá, đảm bảo chất lượng và hiệu quả tối đa cho doanh nghiệp của bạn.
      </p>
    </motion.header>
  );
}
